// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "title-QAfC9";
var _4 = "slider-3xBkx";
var _5 = "header-3tX02";
export { _1 as "__esModule", _2 as "mobile", _3 as "title", _4 as "slider", _5 as "header" }
export default { "__esModule": _1, "mobile": _2, "title": _3, "slider": _4, "header": _5 }
